import { Inject } from '@nestjs/common'
import { ClassDefinition } from './types'
import { getClientToken } from './utils'

export const InjectAws = <C extends ClassDefinition>(client: C, key = '') => {
	const providerToken = getClientToken(client, key)

	return Inject(providerToken)
}
